
























































































































































import {Component, Ref, Vue} from "vue-property-decorator";
import {Container} from "typescript-ioc";
import {
  DeviceControl,
  DeviceControlTmpl,
  DeviceControlTmplType,
  DeviceEventControlTmpl,
  DeviceServiceControlTmpl
} from "@/module/device/DeviceControlTmpl";
import DeviceApi from "@/module/device/DeviceApi";
import deviceModule from "@/store/module/DeviceModule";
import VueJsonPretty from 'vue-json-pretty';
import JsonEditor from '@/component/JsonEditor/index.vue'
import ArrayUtil from "tools-ts/src/util/ArrayUtil";
import {ResourceType, resourceTypeZh} from "@/model/ThingModel";
import {DeviceType} from '@/module/device/DeviceType';
import {End} from "@/module/common/End";
import DeviceDebugApi from "@/module/device/DeviceDebugApi";
import {DmqttEventPqForm} from "@/form/DeviceMqttForm";
import _ from 'lodash';
import PaginationTable from "@/component/Table/pagination-table.vue";
import DeviceMqttEventWrapper, {findTmpl} from "@/model/DeviceMqttEventWrapper";
import MqttEventWrapper from "@/model/MqttEventWrapper";
import InfoDialog from "@/component/Dialog/info-dialog.vue";
import DeviceMqttEventApi from "@/module/device/DeviceMqttEventApi";
import {mqttClientTypeZh} from "@/module/mqtt/MqttClientType";
import {MqttEventType} from "@/module/mqtt/MqttEvent";
import RefreshButton from "@/component/Button/refresh-button.vue";
import PropStatus from "@/view/device-manage/device/prop-status.vue";
import DevicePropStatusView from "@/view/device-manage/device/prop-status.vue";
import {delay} from "@/util/delay";
import ThingModelApi from "@/module/thing/ThingModelApi";
import InstrTmpl from "@/module/instr/InstrTmpl";
import InstrTmplItem from "@/component/Thing/instr-tmpl-item.vue";
import {DateUtil} from "tools-ts/src/date/DateUtil";

@Component({
  components: {
    PropStatus,
    RefreshButton,
    VueJsonPretty,
    JsonEditor,
    PaginationTable,
    InfoDialog,
    InstrTmplItem,
  }
})
export default class DeviceDebugView extends Vue {

  private deviceApi = Container.get(DeviceApi)

  private ddebugApi = Container.get(DeviceDebugApi)

  private get device() {
    return deviceModule.active
  }

  private mockOnline() {
    this.ddebugApi.online(this.device.id, this.device.online)
    deviceModule.activate(this.device)
  }

  private _controlTmpls: Array<DeviceControlTmpl> = []
  private controlTmpls: Array<DeviceControlTmpl> = []

  private initControlTmpls() {
    let controlTmpls: Array<DeviceControlTmpl>
    switch (this.end) {
      case End.SERVER:
        controlTmpls = _.filter(this._controlTmpls, (controlTmpl) => {
          return controlTmpl.resourceType == ResourceType.SERVICE
        })
        break
      default:
        controlTmpls = this._controlTmpls
    }

    if (controlTmpls.length > 0) {
      this.controlTmpl = controlTmpls[0]
      this.funId = this.controlTmpl.funId
    }
    this.controlTmpls = controlTmpls
  }

  private DeviceType = DeviceType
  private deviceType = DeviceType.VIRTUAL

  private get isRealDevice() {
    return this.deviceType == DeviceType.REAL
  }

  private End = End
  private end = End.DEVICE

  private get controlTmplMap(): Map<number, DeviceControlTmpl> {
    return ArrayUtil.groupById(this.controlTmpls, it => {
      return it.funId
    })
  }

  private funId = -1
  private controlTmpl: DeviceControlTmpl = new DeviceServiceControlTmpl()
  private resourceTypeZh = resourceTypeZh

  private tmodelApi = Container.get(ThingModelApi)

  private instrTmplsMap = new Map<number, InstrTmpl>()

  private async created() {
    await this.getControlTmpls()
    this.initControlTmpls()
    const instrTmpls = await this.tmodelApi.instrTmpls(this.device.product.id)
    this.instrTmplsMap = ArrayUtil.groupById(instrTmpls, (tmpl) => {
      return tmpl.funId
    })
  }

  private async getControlTmpls() {
    this._controlTmpls = await this.deviceApi.controlTmpls(this.device.id)
  }

  private changeControlTmpl(funId: number) {
    this.controlTmpl = this.controlTmplMap.get(funId) as DeviceControlTmpl
  }

  private async handleSendClick() {
    switch (this.controlTmpl.type) {
      case DeviceControlTmplType.IN_OUT:
      case DeviceControlTmplType.TASK: {
        let control: DeviceControl
        if (this.end == End.SERVER) {
          control = (this.controlTmpl as DeviceServiceControlTmpl).inputControl
          await this.sendFromServerToDevice(control)
        } else {
          control = (this.controlTmpl as DeviceServiceControlTmpl).outputControl
          await this.sendFromDeviceToServer(control)
        }
        break
      }
      case DeviceControlTmplType.REPORT: {
        const control = (this.controlTmpl as DeviceEventControlTmpl).outputControl
        this.sendFromDeviceToServer(control)
        break
      }
    }

    await delay(100)
    this.mqttEventPtable?.refresh()
    this.propStatusView?.refresh()
  }

  private async sendFromServerToDevice(control: DeviceControl) {
    switch (this.controlTmpl.type) {
      case DeviceControlTmplType.IN_OUT:
        await this.ddebugApi.control({
          deviceId: control.deviceId,
          identifier: control.identifier,
          args: control.args,
          end: End.SERVER,
          isRealDevice: this.isRealDevice
        })
        break
      case DeviceControlTmplType.TASK:
        break
    }
  }

  private async sendFromDeviceToServer(control: DeviceControl) {
    switch (this.controlTmpl.type) {
      case DeviceControlTmplType.IN_OUT:
      case DeviceControlTmplType.REPORT:
        await this.ddebugApi.control({
          deviceId: control.deviceId,
          identifier: control.identifier,
          args: control.args,
          end: End.DEVICE,
          isRealDevice: this.isRealDevice
        })
        break
      case DeviceControlTmplType.TASK:
        break
    }
  }

  private dmqttEventApi = Container.get(DeviceMqttEventApi)

  @Ref()
  private mqttEventPtable!: PaginationTable

  @Ref()
  private propStatusView!: DevicePropStatusView

  private mqttEventPqForm =
      new DmqttEventPqForm(this.device.id, {
        createdAtStart: new Date(),
        createdAtEnd: DateUtil.endOfDay(),
        eventTypes: [MqttEventType.MESSAGE_PUBLISH],
        clientTypes: [],
        payload: undefined,
      })

  private async getMqttEventPaging() {
    return this.dmqttEventApi.paging(this.mqttEventPqForm)
  }

  private async refreshMqttEventPaging() {
    await this.mqttEventPtable?.refresh()
  }

  @Ref()
  private jsonDialog!: InfoDialog

  private mqttEventWrapper?: MqttEventWrapper = undefined

  private get mqttEvent() {
    if (this.mqttEventWrapper)
      return JSON.parse(this.mqttEventWrapper.eventJson)
    else return undefined
  }

  private handleDetailClick(wrapper: DeviceMqttEventWrapper) {
    this.mqttEventWrapper = wrapper.mqttEventWrapper
    this.jsonDialog.open()
  }

  private funFmt(wrapper: DeviceMqttEventWrapper): string {
    const tmpl = this.findTmpl(wrapper)
    if (!tmpl) return ''
    return `${tmpl.funId} - ${tmpl.name}`
  }

  private findTmpl(wrapper: DeviceMqttEventWrapper) {
    return findTmpl(wrapper, this.instrTmplsMap)
  }

  private clientTypeFmt(wrapper: DeviceMqttEventWrapper): string {
    return mqttClientTypeZh[wrapper.clientType]
  }

  private handleEndClick() {
    this.initControlTmpls()
  }

  private get control() {
    const controlTmpl = this.controlTmpl
    switch (controlTmpl.type) {
      case DeviceControlTmplType.IN_OUT:
        return (controlTmpl as DeviceServiceControlTmpl).inputControl.args
      case DeviceControlTmplType.REPORT:
        return (controlTmpl as DeviceEventControlTmpl).outputControl.args
      default:
        return {}
    }
  }

  private set control(args: {}) {
    const controlTmpl = this.controlTmpl
    switch (controlTmpl.type) {
      case DeviceControlTmplType.IN_OUT:
        (controlTmpl as DeviceServiceControlTmpl).inputControl.args = args
        break
      case DeviceControlTmplType.REPORT:
        (controlTmpl as DeviceEventControlTmpl).outputControl.args = args
        break
    }
  }
}
